let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a4IWt")).then(() => parcelRequire('fcP5z'));